import { render, staticRenderFns } from "./FaqSatisfPop.vue?vue&type=template&id=68f90cc4&scoped=true&"
import script from "./FaqSatisfPop.vue?vue&type=script&lang=js&"
export * from "./FaqSatisfPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f90cc4",
  null
  
)

component.options.__file = "FaqSatisfPop.vue"
export default component.exports